module.exports = __webpack_public_path__ + "static/media/greenDark.0e0bf62c.png";